import { withDefault, StringParam } from 'use-query-params';
import {
  BaseellaStatus,
  BaseellaStatusTitle,
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';
import { ProcessingTypeEnum } from '../types';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'active',
    label: 'Rule status',
    sortable: true,
  },
  {
    name: 'typeId',
    label: 'Transaction type',
    sortable: true,
  },
  {
    name: 'fromStatus',
    label: 'From status',
    sortable: true,
  },
  {
    name: 'toStatus',
    label: 'To status',
    sortable: true,
  },
  {
    name: 'processingType',
    label: 'Proccessing type',
    sortable: true,
  },
  {
    name: 'pspIntegrationId',
    label: 'Integration type',
    sortable: false,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: false,
    filterModalPlacement: 'right',
  },
  {
    name: 'amount',
    label: 'Amount',
    sortable: true,
  },
  {
    name: 'currenciesIds',
    label: 'Transaction currencies',
    sortable: false,
  },
  {
    name: 'pspPartnerId',
    label: 'Bank',
    sortable: false,
    filterModalPlacement: 'right',
  },
];

export const columnsLabels = {
  active: 'Rule status',
  fromStatus: 'From status',
  toStatus: 'To status',
  typeId: 'Transaction type',
  processingType: 'Proccessing type',
  currencyId: 'Currency',
  pspIntegrationId: 'Integration type',
  pspPartnerId: 'Bank',
};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  fromStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  toStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  typeId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  processingType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspIntegrationId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspPartnerId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'pspIntegrationId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter integration...',
  },
  {
    name: 'pspPartnerId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter bank...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
  {
    name: 'processingType',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'processingType',
        title: 'Minimum amount check',
        value: ProcessingTypeEnum.MINIMUM_AMOUNT_CHECK,
      },
    ],
  },
  {
    name: 'typeId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter type...',
  },
  {
    name: 'fromStatus',
    withClearButton: true,
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.DRAFT,
        value: BaseellaStatus.DRAFT,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.NONE,
        value: BaseellaStatus.NONE,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.NEW,
        value: BaseellaStatus.NEW,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.PROC,
        value: BaseellaStatus.PROC,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.SENT,
        value: BaseellaStatus.SENT,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.ARCH,
        value: BaseellaStatus.ARCH,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.REV,
        value: BaseellaStatus.REV,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.AML,
        value: BaseellaStatus.AML,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.AML_INFO,
        value: BaseellaStatus.AML_INFO,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.AML_REJ,
        value: BaseellaStatus.AML_REJ,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.AML_DONE,
        value: BaseellaStatus.AML_DONE,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.REJECTED,
        value: BaseellaStatus.REJECTED,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.NOT_SIGNED,
        value: BaseellaStatus.NOT_SIGNED,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.READY_TO_SEND,
        value: BaseellaStatus.READY_TO_SEND,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.READY_TO_PSP,
        value: BaseellaStatus.READY_TO_PSP,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.ACCP_OUT,
        value: BaseellaStatus.ACCP_OUT,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.UNDEFINED_FUNDS,
        value: BaseellaStatus.UNDEFINED_FUNDS,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.FX_RATE_REQUEST,
        value: BaseellaStatus.FX_RATE_REQUEST,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.REFUNDED,
        value: BaseellaStatus.REFUNDED,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.BOOKED,
        value: BaseellaStatus.BOOKED,
      },
      {
        name: 'fromStatus',
        title: BaseellaStatusTitle.HELD,
        value: BaseellaStatus.HELD,
      },
    ],
  },
  {
    name: 'toStatus',
    withClearButton: true,
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.DRAFT,
        value: BaseellaStatus.DRAFT,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.NONE,
        value: BaseellaStatus.NONE,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.NEW,
        value: BaseellaStatus.NEW,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.PROC,
        value: BaseellaStatus.PROC,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.SENT,
        value: BaseellaStatus.SENT,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.ARCH,
        value: BaseellaStatus.ARCH,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.REV,
        value: BaseellaStatus.REV,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.AML,
        value: BaseellaStatus.AML,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.AML_INFO,
        value: BaseellaStatus.AML_INFO,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.AML_REJ,
        value: BaseellaStatus.AML_REJ,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.AML_DONE,
        value: BaseellaStatus.AML_DONE,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.REJECTED,
        value: BaseellaStatus.REJECTED,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.NOT_SIGNED,
        value: BaseellaStatus.NOT_SIGNED,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.READY_TO_SEND,
        value: BaseellaStatus.READY_TO_SEND,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.READY_TO_PSP,
        value: BaseellaStatus.READY_TO_PSP,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.ACCP_OUT,
        value: BaseellaStatus.ACCP_OUT,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.UNDEFINED_FUNDS,
        value: BaseellaStatus.UNDEFINED_FUNDS,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.FX_RATE_REQUEST,
        value: BaseellaStatus.FX_RATE_REQUEST,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.REFUNDED,
        value: BaseellaStatus.REFUNDED,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.BOOKED,
        value: BaseellaStatus.BOOKED,
      },
      {
        name: 'toStatus',
        title: BaseellaStatusTitle.HELD,
        value: BaseellaStatus.HELD,
      },
    ],
  },
];
